<div fxLayout="row" fxLayoutWrap fxLayoutAlign="center start" class="game-connect">
    <div fxFlex fxLayout="column" fxLayoutWrap fxLayoutAlign="start center" class="inner-content">
        <div fxFlex>
            <h3>Please enter contract address:</h3>
        </div>
        <div class="example-container">
            <mat-form-field appearance="fill">
                <mat-label>Input</mat-label>
                <!-- <input matInput [value]="address" (change)="setAddress($event.target.value)"> -->
            </mat-form-field>
        </div>
        <div>Balance: {{balanceUSDc}}</div>
    </div>
</div>
